<wiz-hgroup
  #actionContainer
  width="100%"
  height="100%"
  verticalAlign="center"
  [wizTooltip]="fullStr"
  style="padding: 3px; padding-left: 6px;  position: absolute;"
  class="insert clickable-widget">
  
  <wiz-vgroup width="100%" gap="0">
    <wiz-label [wizLabel]="titleStr" 
    class="calendarLabel" width="100%" [wizTextBehavior]="'truncate'" 
    [tooltipText]="fullStr" wizForceTooltip="true" [style.color]="color"></wiz-label>
    <wiz-label [wizLabel]="contentStr" class="calendarLabel" width="100%" [wizTextBehavior]="'truncate'" 
    [tooltipText]="fullStr" wizForceTooltip="true" [style.color]="color"></wiz-label>
  </wiz-vgroup> 

 </wiz-hgroup>
